import React from 'react';
import styled from '@emotion/styled';
import MuiCheckIcon from '@mui/icons-material/Check';
import colors from '../Theme/colors';

const StyledCheckIcon = styled(MuiCheckIcon)`
  color: ${colors.check};
  font-size: 1.25rem;
`;

const Check = (
  properties: Record<string, unknown>,
) => (
  <StyledCheckIcon {...properties} />
);

export default Check;
